import { logger } from '../../util/logger';
import { renderModel } from '../../util/renderModel';
import { HttpClientFactory } from '../httpClient';
import type { ArticleWithComponents } from '../reducers/types';

const { clientTopology } = renderModel.get();
const locale = renderModel.getLocale();

export const getArticleByUri = (
  uri: string,
  httpClient: HttpClientFactory,
): Promise<ArticleWithComponents> => {
  return httpClient
    .getInstance()
    .get(`${clientTopology.articleByUriUrl}/${uri}?locale=${locale}`)
    .then((r) => r.data)
    .catch((error) => {
      logger.error({
        message: `fail to fetch Article by URI: ${uri}`,
        error,
      });
      throw error;
    });
};
